export enum HeaderType {
  LOGIN = 'LOGIN',
  DASHBOARD = 'DASHBOARD',
}

export const ROUTE_PLATFORM = {
  SIGNUP: 'login',
  DASHBOARD: 'dashboard',
  PARTNER: 'partners',
  FAQ: 'faq',
  LEADS: 'leads',
  ACTIVE_CUSTOMER: 'customers',
  LINKED_PARTNER: 'referredPartners',
  PLATFORM: 'platform',
};
